import { Trigger } from '@radix-ui/react-tooltip';
import { PropsWithChildren } from 'react';

import { TooltipTriggerProps } from './Tooltip.types';

export function TooltipTrigger({ children, ...props }: PropsWithChildren<TooltipTriggerProps>) {
  return <Trigger {...props}>{children}</Trigger>;
}
